// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__3uddI","header":"PatientBlock_header__nfA2W","label":"PatientBlock_label__5yc4m","option":"PatientBlock_option__3upqQ"};